import React, { useState, useEffect, useRef } from "react";
import allTeams from "../../data/teams"; // Adjust the import path as necessary
import fetchSchedule from "./fetchSchedule"; // Adjust the import path as necessary
import { Link } from "react-router-dom";
import apiUrl from "../../config";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const LayoutSchedule = () => {
  const [gameWeek, setGameWeek] = useState(null);
  const [gamesOftheDay, setGameOftheDay] = useState(null);
  const [gamesOfLastNight, setGameOfLastNight] = useState(null);
  const newDate = new Date();
  const year = newDate.getFullYear();
  const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(newDate.getDate()).padStart(2, "0");
  const date = `${year}-${month}-${day}`;
  const hours = newDate.getHours();
  const [loading, setLoading] = useState(false);

  // Get yesterday's date properly (handles month/year boundaries)
  const yesterday = new Date(newDate);
  yesterday.setDate(yesterday.getDate() - 1);
  const lastYear = yesterday.getFullYear();
  const lastMonth = String(yesterday.getMonth() + 1).padStart(2, "0");
  const lastday = String(yesterday.getDate()).padStart(2, "0");
  const dateLastNight = String(`${lastYear}-${lastMonth}-${lastday}`);

  const fetchGames = async () => {
    setLoading(true);
    const schedule = await fetchSchedule(date); // Wait for the promise to resolve
    const scheduleLastNight = await fetchSchedule(dateLastNight); // Wait for the promise to resolve
    console.log("Fetched schedule for last night:", scheduleLastNight);
    setLoading(false);
    setGameOftheDay(schedule); // Update state with the resolved value
    setGameOfLastNight(scheduleLastNight);
  };

  useEffect(() => {
    fetchGames(); // Call the async function
  }, [date]);

  useEffect(() => {
    const anyLive = gamesOftheDay?.some(
      (game) => game.gameState === "LIVE" || game.gameState === "CRIT",
    );
    let intervalId;

    if (anyLive) {
      intervalId = setInterval(async () => {
        const schedule = await fetchSchedule(date);
        setGameOftheDay(schedule);
      }, 10000); // 10 seconds
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [gamesOftheDay]);

  const getTitleDate = (dateParam) => {
    const [year, month, day] = dateParam.split("-").map(Number);
    const date = new Date(year, month - 1, day); // month is 0-based
    const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
    const dayOfMonth = date.getDate();
    const monthName = date.toLocaleDateString("en-US", { month: "long" });

    return `${dayName}, ${monthName} ${dayOfMonth}`;
  };

  const getAdjustedTime = (startTimeUTC, venueUTCOffset) => {
    // Parse the startTimeUTC into a Date object
    const date = new Date(startTimeUTC);

    // Extract hours and minutes from the venueUTCOffset
    const [offsetHours, offsetMinutes] = venueUTCOffset.split(":").map(Number);

    // Calculate the total offset in minutes
    const totalOffsetMinutes = offsetHours * 60 + offsetMinutes;

    // Adjust the date by the offset (in minutes)
    date.setUTCMinutes(date.getUTCMinutes() + totalOffsetMinutes);

    // Format the adjusted time into HH:mm
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  let classLive;

  return (
    <div className="teamContent">
      <div className="scheduleLayoutWrapper">
        <h3>Schedule:</h3>
        <h2>{getTitleDate(date)}</h2>
        <div className="scheduleLayout">
          {gamesOftheDay && gamesOftheDay.length > 0 && loading === false ? (
            (console.log("Rendering games for today:", gamesOftheDay),
            gamesOftheDay.map((game) => {
              return (
                <div
                  key={game.id}
                  className={`${game.gameState === "LIVE" ? "live" : game.gameState === "CRIT" ? "crit" : ""}`}
                >
                  <div className={`gameItem`}>
                    <div>
                      <Link to={`/team/${game.awayTeam.abbrev}`}>
                        <img
                          width={60}
                          src={`https://assets.nhle.com/logos/nhl/svg/${game.awayTeam.abbrev}_light.svg`}
                          alt={`${game.awayTeam.commonName.default} logo`}
                        />
                        <h3>
                          {game.awayTeam.commonName.default}{" "}
                          {game.awayTeam.score}
                        </h3>
                      </Link>
                    </div>
                    <div>vs</div>
                    <div>
                      <Link to={`/team/${game.homeTeam.abbrev}`}>
                        <img
                          width={60}
                          src={`https://assets.nhle.com/logos/nhl/svg/${game.homeTeam.abbrev}_light.svg`}
                          alt={`${game.homeTeam.commonName.default} logo`}
                        />
                        <h3>
                          {game.homeTeam.commonName.default}{" "}
                          {game.homeTeam.score}
                        </h3>
                      </Link>{" "}
                    </div>
                    <div>
                      <p className="venu">
                        {getAdjustedTime(
                          game.startTimeUTC,
                          game.venueUTCOffset,
                        )}{" "}
                        at {game.venue.default}
                      </p>
                      <Link to={`/game/${game.id}`}>View Game Details</Link>
                    </div>
                  </div>
                </div>
              );
            }))
          ) : loading === true ? (
            <Box sx={{ display: "flex" }}>
              <CircularProgress />
            </Box>
          ) : (
            "No games scheduled for today."
          )}
        </div>

        <h3>Last night game:</h3>
        <h2>{getTitleDate(dateLastNight)}</h2>
        <div className="scheduleLayout">
          {gamesOfLastNight &&
          gamesOfLastNight.length > 0 &&
          loading === false ? (
            gamesOfLastNight.map((game) => (
              <div key={game.id}>
                <div className="gameItem">
                  <div>
                    <Link to={`/team/${game.awayTeam.abbrev}`}>
                      <img
                        width={60}
                        src={`https://assets.nhle.com/logos/nhl/svg/${game.awayTeam.abbrev}_light.svg`}
                        alt={`${game.awayTeam.commonName.default} logo`}
                      />
                      <h3>
                        {game.awayTeam.commonName.default} {game.awayTeam.score}
                      </h3>
                    </Link>
                  </div>
                  <div>vs</div>
                  <div>
                    <Link to={`/team/${game.homeTeam.abbrev}`}>
                      <img
                        width={60}
                        src={`https://assets.nhle.com/logos/nhl/svg/${game.homeTeam.abbrev}_light.svg`}
                        alt={`${game.homeTeam.commonName.default} logo`}
                      />
                      <h3>
                        {game.homeTeam.commonName.default} {game.homeTeam.score}
                      </h3>
                    </Link>{" "}
                  </div>
                  <div>
                    <p className="venu">
                      {getAdjustedTime(game.startTimeUTC, game.venueUTCOffset)}{" "}
                      at {game.venue.default}
                    </p>
                    <Link to={`/game/${game.id}`}>View Game Details</Link>
                  </div>
                </div>
              </div>
            ))
          ) : loading === true ? (
            <Box sx={{ display: "flex" }}>
              <CircularProgress />
            </Box>
          ) : (
            "No games scheduled for last night."
          )}
          {console.log("Rendering games for last night:", gamesOfLastNight)}
        </div>
      </div>
    </div>
  );
};

export default LayoutSchedule;
